module.exports = __webpack_public_path__ + "static/media/Leiyingtao.8736e24f.png";